import styled from '@emotion/styled';
import { fontSize, fontWeight } from 'src/domains/common/universes/star/starsports.config';
import { LogoGambleAwareV2 } from 'src/domains/layouts/shared/assets/logotypes/responsible-gambling/LogoGambleAwareV2';
import { LogoGamblingHelpline } from 'src/domains/layouts/shared/assets/logotypes/responsible-gambling/LogoGamblingHelpline';
import { withConfig } from 'src/withConfig';
import { AccountNavigationLink } from 'src/domains/layouts/webview/components/accountNavigationLink/AccountNavigationLink';

export const ResponsibleGamblingLinksText = withConfig(theme => styled('span', { label: 'ResponsibleGamblingLinksText' })<{type: 'primary' | 'secondary'}>`
    font-size: ${fontSize.xSmall};
    color: ${({ type }): string => type === 'primary' ? theme.star.iconContainer.txtColor : theme.star.iconContainer.txtColorSecondary};
`);

export const LogoGamblingHelplineWrapper = styled(LogoGamblingHelpline, { label: 'LogoGamblingHelplineWrapper' })`
    width: 78px;
`;

export const LogoGambleAwareV2Wrapper = styled(LogoGambleAwareV2, { label: 'LogoGambleAwareV2Wrapper' })`
    width: 91px;
`;

export const SecondaryLinksContainer = styled('div', { label: 'SecondaryLinksContainer' })`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
`;

export const SecondaryLink = withConfig(theme => styled(AccountNavigationLink, { label: 'SecondaryLink' })`
    font-weight: ${fontWeight.xMedium};
    font-size: ${fontSize.small};
    line-height: 1.25;
    letter-spacing: 0;
    text-decoration: none;
    cursor: pointer;
    color: ${theme.star.iconContainer.txtColorTertiary};
`);

export const VerticalDivider = withConfig(theme => styled('span', { label: 'VerticalDivider' })`
    display: inline-block;
    width: 1px;
    height: 16px;
    margin: 0 8px;
    background-color: ${theme.star.iconContainer.txtColorQuaternary};
`);
